{
  "CSAT": {
    "TITLE": "Ohodnoťte konverzáciu",
    "PLACEHOLDER": "Povedzte nám viac...",
    "RATINGS": {
      "POOR": "😞 Zlé",
      "FAIR": "😑 Ucházejúce",
      "AVERAGE": "😐 Priemerné",
      "GOOD": "😀 Dobré",
      "EXCELLENT": "😍 Vynikajúce"
    }
  }
}
